import { useState, useCallback } from 'react';
import GoogleMapsApi from 'api-services/GoogleMapsApi';
const repackSuggestions = (googleSuggestions) => googleSuggestions.map(({ place_id, description }) => ({
    placeId: place_id,
    label: description
}));
const useGooglePlaceSuggestions = () => {
    const [suggestions, setSuggestions] = useState({ objects: [], timestamp: 0 });
    const getSuggestions = useCallback(async (input, types) => {
        const timestamp = Date.now();
        try {
            const result = await GoogleMapsApi.getPlaceSuggestions(input, types);
            setSuggestions((suggestions) => {
                // prevent race conditions (an older request might finish later and override state)
                if (timestamp > suggestions.timestamp) {
                    const objects = repackSuggestions(result);
                    return { objects, timestamp };
                }
                else {
                    return suggestions;
                }
            });
        }
        catch {
            // in case of an error clear the list but keep the timestamp
            setSuggestions((suggestions) => ({ objects: [], timestamp: suggestions.timestamp }));
        }
    }, []);
    const clearSuggestions = useCallback(() => {
        setSuggestions({ objects: [], timestamp: 0 });
    }, []);
    return {
        suggestions: suggestions.objects,
        getSuggestions,
        clearSuggestions
    };
};
export default useGooglePlaceSuggestions;
//# sourceMappingURL=useGooglePlaceSuggestions.js.map